"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppstoreApps = exports.getMarketplaceApps = exports.processSpaceJoin = exports.applyJoinSpace = exports.searchTemplate = exports.vCodeExchange = exports.getSpaceAudit = exports.getUserIntegralRecords = exports.getUserIntegral = exports.getFavoriteNodeList = exports.moveFavoriteNode = exports.updateNodeFavoriteStatus = exports.trashDelete = exports.trashRecover = exports.getTrashList = exports.subscribeInfo = exports.submitQuestionnaire = exports.addRole = exports.batchDeleteRole = exports.batchEditRole = exports.editRole = exports.listRole = exports.deleteRole = exports.disableRoleExtend = exports.enableRoleExtend = exports.commitRemind = exports.searchUnitInfoVo = exports.loadOrSearchEmbed = exports.loadOrSearch = exports.templateRecommend = exports.templateNameValidate = exports.triggerWizard = exports.useTemplate = exports.templateDirectory = exports.getTemplateAlbumsRecommend = exports.getTemplateAlbum = exports.deleteTemplate = exports.getTemplateCategories = exports.getTemplateList = exports.getTemplateCategory = exports.createTemplate = exports.transferNoticeToRead = exports.createReport = exports.createNotification = exports.getNotificationList = exports.getNotificationPage = exports.getNotificationStatistics = exports.unBindAccount = exports.getAttachPreviewUrl = exports.uploadAttach = void 0;
exports.getRecentlyBrowsedFolder = exports.initRoles = exports.deleteRoleMember = exports.addRoleMember = exports.getRoleMemberList = exports.updateOrgRole = exports.deleteOrgRole = exports.createRole = exports.getRoleList = exports.getSubscribeActiveEvents = exports.getS3Callback = exports.getUploadCertificate = exports.getURLMetaBatch = exports.getNoPermissionMember = exports.getNodeInfoWindow = exports.applyResourceChangesets = exports.updateSecuritySetting = exports.updateLabsFeatureList = exports.getLabsFeatureList = exports.getLabsFeature = exports.unBindEmail = exports.unBindMobile = exports.getSpaceAdList = exports.getAvInfo = exports.disableApp = exports.enableApp = exports.getAppInstanceById = exports.deleteAppInstance = exports.createAppInstance = exports.getAppInstances = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = require("../../../config");
const Url = __importStar(require("./url"));
const urlcat_1 = __importDefault(require("urlcat"));
__exportStar(require("../../enterprise"), exports);
__exportStar(require("../../user/api/api.auth"), exports);
__exportStar(require("../../user/api/api.user"), exports);
__exportStar(require("../../space/api/api.space"), exports);
__exportStar(require("../../org/api/api.org"), exports);
axios_1.default.defaults.baseURL = Url.BASE_URL;
const nestBaseURL = process.env.NEXT_PUBLIC_NEXT_API;
/**
 * Upload Attachment
 *
 * @param formData attachment data
 */
function uploadAttach(file) {
    return axios_1.default.post(Url.UPLOAD_ATTACH, file, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}
exports.uploadAttach = uploadAttach;
/**
 * Get attachment's preview url
 *
 * @param token cloud file token
 */
function getAttachPreviewUrl(spaceId, token, attname) {
    return axios_1.default.post((0, urlcat_1.default)(Url.OFFICE_PREVIEW, { spaceId }), {
        token,
        attname,
    });
}
exports.getAttachPreviewUrl = getAttachPreviewUrl;
/**
 * @description unbind account
 * @export
 * @param {BindAccount} type
 * @returns
 */
function unBindAccount(type) {
    return axios_1.default.post(Url.UN_BIND, {
        type,
    });
}
exports.unBindAccount = unBindAccount;
/**
 * get notifications statistics
 */
function getNotificationStatistics() {
    return axios_1.default.get(Url.NOTIFICATION_STATISTICS);
}
exports.getNotificationStatistics = getNotificationStatistics;
/**
 * notification list with pagination
 * @param pageObjectParams pagination params
 * @param isRead 1:read 2:unread, if empty, get all
 */
function getNotificationPage(isRead, rowNo) {
    return axios_1.default.get(Url.NOTIFICATION_PAGE, {
        params: {
            isRead: isRead ? 1 : 0,
            rowNo,
            pageSize: config_1.ConfigConstant.NOTICE_LIST_SIZE,
        },
    });
}
exports.getNotificationPage = getNotificationPage;
/**
 * get notification list
 *
 * @param isRead
 * @param notifyType
 * @returns
 */
function getNotificationList(isRead, notifyType) {
    return axios_1.default.get(Url.NOTIFICATION_LIST, {
        params: {
            isRead: isRead ? 1 : 0,
            notifyType,
        },
    });
}
exports.getNotificationList = getNotificationList;
/**
 * create notification
 * @param data
 * @returns
 */
function createNotification(data) {
    return axios_1.default.post(Url.CREATE_NOTIFICATION, data);
}
exports.createNotification = createNotification;
/**
 * create tip-off report
 *
 * @param nodeId
 * @param reportReason
 */
function createReport(nodeId, reportReason) {
    return axios_1.default.post(Url.CREATE_REPORTS, {
        nodeId,
        reportReason,
    });
}
exports.createReport = createReport;
/**
 * mark notification as read
 * @param id notification id, batch edit support
 * @param isAll  total or not
 */
function transferNoticeToRead(id, isAll) {
    return axios_1.default.post(Url.TRANSFER_NOTICE_TO_READ, {
        id,
        isAll: isAll ? 1 : 0,
    });
}
exports.transferNoticeToRead = transferNoticeToRead;
/**
 * create template
 * @param nodeId
 * @param name
 * @param data
 * @returns
 */
function createTemplate(nodeId, name, data = true) {
    return axios_1.default.post(Url.CREATE_TEMPLATE, {
        nodeId,
        name,
        data,
    });
}
exports.createTemplate = createTemplate;
/**
 * get official template category list
 * @param categoryCodes
 * @returns
 */
function getTemplateCategory(categoryCodes) {
    return axios_1.default.get(Url.OFFICIAL_TEMPLATE_CATEGORY, {
        params: {
            categoryCodes,
        },
    });
}
exports.getTemplateCategory = getTemplateCategory;
/**
 * get official template list
 * @param spaceId
 * @param categoryCode
 * @param isPrivate
 * @param headers
 * @returns
 */
function getTemplateList(spaceId, categoryCode, isPrivate, headers) {
    return axios_1.default.get((0, urlcat_1.default)(Url.SPACE_TEMPLATES, { spaceId }), {
        params: {
            categoryCode,
            isPrivate,
        },
        headers,
    });
}
exports.getTemplateList = getTemplateList;
/**
 * get official template category content
 * @param categoryCode
 * @param headers
 * @returns
 */
function getTemplateCategories(categoryCode, headers) {
    return axios_1.default.get((0, urlcat_1.default)(Url.TEMPLATE_CATEGORIES, { categoryCode }), {
        headers,
    });
}
exports.getTemplateCategories = getTemplateCategories;
/**
 * Delete templates
 *
 * @param tempalte
 * @returns
 */
const deleteTemplate = (tempalte) => {
    return axios_1.default.delete(`${Url.DELETE_TEMPLATE}${tempalte}`);
};
exports.deleteTemplate = deleteTemplate;
/**
 * Get template album content
 * @param albumId
 * @param headers
 * @returns
 */
function getTemplateAlbum(albumId, headers) {
    return axios_1.default.get((0, urlcat_1.default)(Url.TEMPLATE_ALBUMS, { albumId }), {
        headers,
    });
}
exports.getTemplateAlbum = getTemplateAlbum;
/**
 * Get template album content
 *
 * @param albumId
 * @param maxCount
 * @param headers
 * @returns
 */
function getTemplateAlbumsRecommend(albumId, maxCount, headers) {
    return axios_1.default.get(Url.TEMPLATE_ALBUMS_RECOMMEND, {
        params: {
            excludeAlbumId: albumId,
            maxCount,
        },
        headers,
    });
}
exports.getTemplateAlbumsRecommend = getTemplateAlbumsRecommend;
/**
 * get template directory information
 * @param templateId
 * @param isPrivate
 * @param categoryCode
 * @returns
 */
const templateDirectory = (templateId, isPrivate, categoryCode) => {
    return axios_1.default.get(Url.TEMPLATE_DIRECTORY, {
        params: {
            templateId,
            isPrivate,
            categoryCode,
        },
    });
};
exports.templateDirectory = templateDirectory;
/**
 * use template
 *
 * @param templateId
 * @param parentId
 * @param data
 * @returns
 */
const useTemplate = (templateId, parentId, data) => {
    return axios_1.default.post(Url.USE_TEMPLATE, {
        templateId,
        parentId,
        data,
    });
};
exports.useTemplate = useTemplate;
const triggerWizard = (wizardId) => {
    return axios_1.default.post(Url.TRIGGER_WIZARD, {
        wizardId,
    });
};
exports.triggerWizard = triggerWizard;
/**
 * validate the template's existence
 * @param name
 * @returns
 */
const templateNameValidate = (name) => {
    return axios_1.default.get(Url.TEMPLATE_NAME_VALIDATE, {
        params: {
            name,
        },
    });
};
exports.templateNameValidate = templateNameValidate;
/**
 * get hot recommend content
 * @param headers
 * @returns
 */
const templateRecommend = (headers) => {
    return axios_1.default.get(Url.TEMPLATE_RECOMMEND, {
        headers,
    });
};
exports.templateRecommend = templateRecommend;
/**
 * load or search members.
 * display the most selected recent 10 records for Member Field choices
 * @param param0
 * @returns
 */
function loadOrSearch({ filterIds, keyword, names, unitIds, linkId, all, searchEmail }) {
    if (unitIds && unitIds.includes('opt')) {
        return Promise.reject();
    }
    return axios_1.default.get(Url.LOAD_OR_SEARCH, {
        params: {
            filterIds,
            keyword,
            names,
            unitIds,
            linkId,
            all,
            searchEmail,
        },
    });
}
exports.loadOrSearch = loadOrSearch;
function loadOrSearchEmbed(embedId, { filterIds, keyword, names, unitIds, linkId, all, searchEmail }) {
    return axios_1.default.get((0, urlcat_1.default)(Url.LOAD_OR_SEARCH_EMBED, { embedId }), {
        baseURL: nestBaseURL,
        params: {
            filterIds,
            keyword,
            names,
            unitIds,
            linkId,
            all,
            searchEmail,
        },
    });
}
exports.loadOrSearchEmbed = loadOrSearchEmbed;
/**
 * Search unit(folder/file) info
 *
 * @param names
 * @param linkId
 * @returns
 */
function searchUnitInfoVo(names, linkId) {
    return axios_1.default.post(Url.SEARCH_UNIT_INFO_VO, {
        names,
        linkId,
    });
}
exports.searchUnitInfoVo = searchUnitInfoVo;
/**
 * when member field change, submit increment.
 * backend will aggregate them to send notice.
 * @param data
 * @returns
 */
function commitRemind(data) {
    return axios_1.default.post(Url.COMMIT_REMIND, data);
}
exports.commitRemind = commitRemind;
/**
 * Enable node permission (inheritance parent)
 *
 * @param nodeId
 * @returns
 */
function enableRoleExtend(nodeId) {
    return axios_1.default.post(Url.ENABLE_ROLE_EXTEND + `?nodeId=${nodeId}`);
}
exports.enableRoleExtend = enableRoleExtend;
/**
 * Disable node permission (inheritance parent)
 * @param nodeId
 * @param includeExtend
 * @returns
 */
function disableRoleExtend(nodeId, includeExtend) {
    const params = includeExtend ? { includeExtend } : {};
    return axios_1.default.post(Url.DISABLE_ROLE_EXTEND + `?nodeId=${nodeId}`, params);
}
exports.disableRoleExtend = disableRoleExtend;
/**
 * Delete node role
 * @param nodeId
 * @param unitId
 * @returns
 */
function deleteRole(nodeId, unitId) {
    return axios_1.default.delete(Url.DELETE_ROLE, {
        data: {
            nodeId,
            unitId,
        },
    });
}
exports.deleteRole = deleteRole;
/**
 * Query the node role list
 *
 * @param nodeId
 * @param includeAdmin
 * @param includeExtend
 * @param includeSelf
 * @returns
 */
function listRole(nodeId, includeAdmin, includeExtend, includeSelf) {
    return axios_1.default.get(Url.NODE_LIST_ROLE, {
        params: {
            nodeId,
            includeAdmin,
            includeExtend,
            includeSelf,
        },
    });
}
exports.listRole = listRole;
/**
 * Edit the role of the node's organization unit
 *
 * @param nodeId
 * @param unitId
 * @param role
 * @returns
 */
function editRole(nodeId, unitId, role) {
    return axios_1.default.post(Url.EDIT_ROLE, {
        nodeId,
        unitId,
        role,
    });
}
exports.editRole = editRole;
/**
 * Batch edit the role of the node's organization unit
 * @param nodeId
 * @param unitIds
 * @param role
 * @returns
 */
function batchEditRole(nodeId, unitIds, role) {
    return axios_1.default.post(Url.BATCH_EDIT_ROLE, {
        nodeId,
        unitIds,
        role,
    });
}
exports.batchEditRole = batchEditRole;
/**
 * Batch delete node roles
 * @param nodeId
 * @param unitIds
 * @returns
 */
function batchDeleteRole(nodeId, unitIds) {
    return axios_1.default.delete(Url.BATCH_DELETE_ROLE, {
        data: { unitIds, nodeId },
    });
}
exports.batchDeleteRole = batchDeleteRole;
/**
 * Add role to specified organization unit
 * @param nodeId
 * @param unitIds
 * @param role
 * @returns
 */
function addRole(nodeId, unitIds, role) {
    return axios_1.default.post(Url.ADD_ROLE, {
        nodeId,
        unitIds,
        role,
    });
}
exports.addRole = addRole;
/**
 * Submit questionnaire
 *
 * TODO: remove this hard code api
 *
 * @param data
 * @returns
 */
function submitQuestionnaire(data) {
    return (0, axios_1.default)({
        method: 'post',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        url: 'https://e6l40faiq2.execute-api.cn-northwest-1.amazonaws.com.cn/funsion-feeback-form',
        data: { data },
    });
}
exports.submitQuestionnaire = submitQuestionnaire;
/**
 * get space subscription info
 *
 * @param spaceId
 * @returns
 */
function subscribeInfo(spaceId) {
    return axios_1.default.get(Url.SUBSCRIBE_INFO + spaceId);
}
exports.subscribeInfo = subscribeInfo;
/**
 * Query trash's node list
 * @param params
 * @returns
 */
function getTrashList(params) {
    return axios_1.default.get(Url.TRASH_LIST, { params });
}
exports.getTrashList = getTrashList;
/**
 * Recover trash node
 * @param nodeId
 * @param parentId
 * @returns
 */
function trashRecover(nodeId, parentId) {
    return axios_1.default.post(Url.TRASH_RECOVER, {
        nodeId,
        parentId,
    });
}
exports.trashRecover = trashRecover;
/**
 * Delete trash's node
 * @param nodeId
 * @returns
 */
function trashDelete(nodeId) {
    return axios_1.default.delete(`${Url.TRASH_DELETE}${nodeId}`);
}
exports.trashDelete = trashDelete;
/**
 * update node's favorite status
 *
 * @param nodeId
 * @returns
 */
function updateNodeFavoriteStatus(nodeId) {
    return axios_1.default.post(`${Url.UPDATE_NODE_FAVORITE_STATUS}${nodeId}`);
}
exports.updateNodeFavoriteStatus = updateNodeFavoriteStatus;
/**
 * Move favorite node position
 *
 * @param nodeId
 * @param preNodeId
 * @returns
 */
function moveFavoriteNode(nodeId, preNodeId) {
    return axios_1.default.post(Url.MOVE_FAVORITE_NODE, {
        nodeId,
        preNodeId,
    });
}
exports.moveFavoriteNode = moveFavoriteNode;
/**
 * Query favorite node list
 * @returns
 */
function getFavoriteNodeList() {
    return axios_1.default.get(Url.FAVORITE_NODE_LIST);
}
exports.getFavoriteNodeList = getFavoriteNodeList;
/**
 * get user's point(credit) info
 * @returns
 */
function getUserIntegral() {
    return axios_1.default.get(Url.USER_CREDIT);
}
exports.getUserIntegral = getUserIntegral;
/**
 * get user's point(credit) transaction list
 *
 * @param pageNo
 * @returns
 */
function getUserIntegralRecords(pageNo) {
    const pageObjectParams = JSON.stringify({
        pageSize: config_1.ConfigConstant.USER_INTEGRAL_RECORDS_PAGE_SIZE,
        order: 'createdAt',
        sort: config_1.ConfigConstant.SORT_DESC,
        pageNo,
    });
    return axios_1.default.get(Url.USER_INTEGRAL_RECORDS, {
        params: { pageObjectParams },
    });
}
exports.getUserIntegralRecords = getUserIntegralRecords;
/**
 * query audit log list with pagination
 *
 * @param param0
 * @returns
 */
const getSpaceAudit = (_a) => {
    var { spaceId } = _a, params = __rest(_a, ["spaceId"]);
    return axios_1.default.get((0, urlcat_1.default)(Url.SPACE_AUDIT, { spaceId }), {
        params: Object.assign({}, params),
    });
};
exports.getSpaceAudit = getSpaceAudit;
/**
 * Reedem the code award
 * @param code
 * @returns
 */
function vCodeExchange(code) {
    return axios_1.default.post(Url.CODE_EXCHANGE + code);
}
exports.vCodeExchange = vCodeExchange;
/**
 * fuzzy search template
 *
 * @param keyword
 * @param className
 * @returns
 */
function searchTemplate(keyword, className) {
    return axios_1.default.get(Url.TEMPLATE_SEARCH, {
        params: {
            keyword,
            className,
        },
    });
}
exports.searchTemplate = searchTemplate;
/**
 * apply to join space
 *
 * @param spaceId
 * @returns
 */
function applyJoinSpace(spaceId) {
    return axios_1.default.post(Url.APPLY_JOIN_SPACE, { spaceId });
}
exports.applyJoinSpace = applyJoinSpace;
/**
 * process the message of "someone join space"
 *
 * @param notifyId
 * @param agree
 * @returns
 */
function processSpaceJoin(notifyId, agree) {
    return axios_1.default.post(Url.PROCESS_SPACE_JOIN, {
        notifyId,
        agree,
    });
}
exports.processSpaceJoin = processSpaceJoin;
/**
 * get 3rd apps list (marketplace)
 *
 * @param spaceId
 * @returns
 */
function getMarketplaceApps(spaceId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_MARKETPLACE_APPS, { spaceId }));
}
exports.getMarketplaceApps = getMarketplaceApps;
/**
 * get 3rd apps list (marketplace)
 * @returns
 */
function getAppstoreApps() {
    return axios_1.default.get(Url.GET_APPSTORES_APPS);
}
exports.getAppstoreApps = getAppstoreApps;
/**
 * get app instances (enabled)
 * @param spaceId
 * @returns
 */
function getAppInstances(spaceId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.APP_INSTANCE, { spaceId }));
}
exports.getAppInstances = getAppInstances;
/**
 *
 * create app instances (before use it, you need to create it(wecom/lark) first)
 *
 * @param spaceId
 * @param appId
 * @returns
 */
function createAppInstance(spaceId, appId) {
    return axios_1.default.post(Url.APP_INSTANCE, { spaceId, appId });
}
exports.createAppInstance = createAppInstance;
/**
 *
 * delete app instance
 *
 * @param appInstanceId
 * @returns
 */
function deleteAppInstance(appInstanceId) {
    return axios_1.default.delete((0, urlcat_1.default)(Url.SINGLE_APP_INSTANCE, { appInstanceId }));
}
exports.deleteAppInstance = deleteAppInstance;
/**
 *
 * get app instance by id
 *
 * @param appInstanceId
 * @returns
 */
function getAppInstanceById(appInstanceId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.SINGLE_APP_INSTANCE, { appInstanceId }));
}
exports.getAppInstanceById = getAppInstanceById;
/**
 * enable app
 * @param spaceId
 * @param appId
 * @returns
 */
function enableApp(spaceId, appId) {
    return axios_1.default.post((0, urlcat_1.default)(Url.APP_ENABLE, { spaceId, appId }));
}
exports.enableApp = enableApp;
/**
 * disable app
 * @param spaceId
 * @param appId
 * @returns
 */
function disableApp(spaceId, appId) {
    return axios_1.default.post((0, urlcat_1.default)(Url.APP_DISABLE, { spaceId, appId }));
}
exports.disableApp = disableApp;
/**
 * get audio and video metadata
 *
 * @param url
 * @returns
 */
// https://developer.qiniu.com/dora/1247/audio-and-video-metadata-information-avinfo
function getAvInfo(url) {
    return axios_1.default.get(url);
}
exports.getAvInfo = getAvInfo;
/**
 * get space admin ad list
 * the config data stored in the space's config: https://vika.cn/workbench/dst9vf4SSYhEAme66b/viwRvDFWeP11B
 * if use cloud function to get API, every 10 minutes will sync once
 * @returns
 */
function getSpaceAdList() {
    return axios_1.default.get('https://service-p4w3x0tq-1254196833.gz.apigw.tencentcs.com/release/ads');
}
exports.getSpaceAdList = getSpaceAdList;
function unBindMobile(code) {
    return axios_1.default.post(Url.USER_UNBIND_MOBILE, { code });
}
exports.unBindMobile = unBindMobile;
function unBindEmail(code) {
    return axios_1.default.post(Url.USER_UNBIND_EMAIL, { code });
}
exports.unBindEmail = unBindEmail;
/**
 * get labs features
 * @param spaceId
 * @returns
 */
function getLabsFeature(spaceId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_LABS_FEATURE, { spaceId }));
}
exports.getLabsFeature = getLabsFeature;
/**
 * get labs features list
 * @returns
 */
function getLabsFeatureList() {
    return axios_1.default.get(Url.GET_LABS_FEATURE_LIST);
}
exports.getLabsFeatureList = getLabsFeatureList;
/**
 * update labs features list
 * @param key
 * @param isEnabled
 * @param spaceId
 * @returns
 */
function updateLabsFeatureList(key, isEnabled, spaceId) {
    return axios_1.default.post(Url.GET_LABS_FEATURE, {
        key,
        isEnabled,
        spaceId,
    });
}
exports.updateLabsFeatureList = updateLabsFeatureList;
function updateSecuritySetting(config) {
    return axios_1.default.post(Url.UPDATE_SECURITY_SETTING, config);
}
exports.updateSecuritySetting = updateSecuritySetting;
function applyResourceChangesets(changesets, roomId) {
    return axios_1.default.post(Url.APPLY_RESOURCE_CHANGESETS, {
        changesets,
        roomId,
    }, {
        baseURL: nestBaseURL,
    });
}
exports.applyResourceChangesets = applyResourceChangesets;
/**
 * get node info - (file info UI modal)
 * @param nodeId
 * @returns
 */
function getNodeInfoWindow(nodeId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_NODE_INFO_WINDOW, { nodeId }));
}
exports.getNodeInfoWindow = getNodeInfoWindow;
/**
 * get members that have no permissions
 *
 * @param nodeId
 * @param unitIds
 * @returns
 */
function getNoPermissionMember(nodeId, unitIds) {
    return axios_1.default.post(Url.NO_PERMISSION_MEMBER, { nodeId, unitIds });
}
exports.getNoPermissionMember = getNoPermissionMember;
/**
 * batch get url info,  for URL field recognition
 *
 * @param urls
 * @returns
 */
const getURLMetaBatch = (urls) => axios_1.default.post(Url.GET_URL_META_BATCH, { urls });
exports.getURLMetaBatch = getURLMetaBatch;
const getUploadCertificate = (params) => {
    return axios_1.default.post(Url.UPLOAD_PRESIGNED_URL, params);
};
exports.getUploadCertificate = getUploadCertificate;
const getS3Callback = (params) => {
    return axios_1.default.post(Url.UPLOAD_CALLBACK, params);
};
exports.getS3Callback = getS3Callback;
const getSubscribeActiveEvents = () => {
    return axios_1.default.get(Url.SUBSCRIBE_ACTIVE_EVENT);
};
exports.getSubscribeActiveEvents = getSubscribeActiveEvents;
/**
 * get role list
 * @returns
 */
const getRoleList = () => {
    return axios_1.default.get(Url.GET_ROLE_LIST);
};
exports.getRoleList = getRoleList;
/**
 * create organization role
 * @param roleName
 * @returns
 */
const createRole = (roleName) => {
    return axios_1.default.post(Url.CREATE_NEW_ROLE, { roleName });
};
exports.createRole = createRole;
/**
 * delete organization role
 * @param roleId
 * @returns
 */
const deleteOrgRole = (roleId) => {
    return axios_1.default.delete((0, urlcat_1.default)(Url.DELETE_ORG_ROLE, { roleId }));
};
exports.deleteOrgRole = deleteOrgRole;
/**
 * update organization role
 * @param roleId
 * @param roleName
 * @returns
 */
const updateOrgRole = (roleId, roleName) => {
    return axios_1.default.patch((0, urlcat_1.default)(Url.UPDATE_ORG_ROLE, { roleId }), { roleName });
};
exports.updateOrgRole = updateOrgRole;
/**
 * get role's members list
 * @param roleId
 * @param page
 * @returns
 */
const getRoleMemberList = (roleId, page) => {
    const pageObjectParams = JSON.stringify(page);
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_MEMBER_LIST_BY_ROLE, { roleId }), {
        params: { pageObjectParams },
    });
};
exports.getRoleMemberList = getRoleMemberList;
/**
 * add member to role
 * @param roleId
 * @param unitList
 * @returns
 */
const addRoleMember = (roleId, unitList) => {
    return axios_1.default.post((0, urlcat_1.default)(Url.ADD_ROLE_MEMBER, { roleId }), { unitList });
};
exports.addRoleMember = addRoleMember;
/**
 * delete member from role
 * @param roleId
 * @param unitIds
 * @returns
 */
const deleteRoleMember = (roleId, unitIds) => {
    return axios_1.default.delete((0, urlcat_1.default)(Url.DELETE_ROLE_MEMBER, { roleId }), { data: { unitIds } });
};
exports.deleteRoleMember = deleteRoleMember;
/**
 * init roles
 * @returns
 */
const initRoles = () => {
    return axios_1.default.post(Url.INIT_ROLE);
};
exports.initRoles = initRoles;
// recently browsed folder
const getRecentlyBrowsedFolder = () => {
    return axios_1.default.get(Url.NODE_RECENTLY_BROWSED);
};
exports.getRecentlyBrowsedFolder = getRecentlyBrowsedFolder;
//# sourceMappingURL=api.js.map